import { Remark } from 'react-remark'
import type { CSSProps } from 'ui'

import { PreStyled } from './code-block.styled'
import { getLanguage, rehypePrism } from './utils'

import type { FCC } from 'types/react'

type CodeBlockProps = {
  language: string
  isDiff?: boolean
  showLineNumbers?: boolean
} & CSSProps

const CodeBlock: FCC<CodeBlockProps> = props => {
  const { children, language, isDiff, showLineNumbers = true, css } = props
  const lang = getLanguage(language)
  const code = children?.toString().trim() ?? ''
  const markdown = `~~~${isDiff ? 'diff-' : ''}${lang}\n${code}\n~~~`

  return (
    <Remark
      rehypeReactOptions={{
        components: {
          pre: props => <PreStyled css={css}>{props.children}</PreStyled>
        }
      }}
      // @ts-ignore -- mismatch between types (lazy typing on react-remark's part)
      rehypePlugins={[[rehypePrism, { ignoreMissing: true, showLineNumbers }]]}
    >
      {markdown}
    </Remark>
  )
}

export default CodeBlock
